import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import blogData from "../data/blogposts.json";

interface Post {
  title: string;
  description: string;
  date?: string;
}

const generateGradientBorder = (title: string) => {
  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash = title.charCodeAt(i) + ((hash << 5) - hash);
  }

  const r1 = (hash % 256);
  const g1 = ((hash >> 8) % 256);
  const b1 = ((hash >> 16) % 256);

  const r2 = ((hash >> 24) % 256);
  const g2 = ((hash >> 16) % 256);
  const b2 = ((hash >> 8) % 256);

  return `linear-gradient(45deg, rgb(${r1}, ${g1}, ${b1}), rgb(${r2}, ${g2}, ${b2}))`;
};

const Home = () => {
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    const updatedPosts: Post[] = (blogData.posts as Post[]).map(post => ({
      ...post,
      date: post.date || new Date().toLocaleString(),
    }));

    updatedPosts.sort((a, b) => {
      return new Date(b.date!).getTime() - new Date(a.date!).getTime();
    });

    setPosts(updatedPosts);
  }, []);

  return (
    <Container className="home-container">
      <h1 className="home-title">Welcome!</h1>
      <h3>I'm Andrew Haitsch and this is a lil website I made to mess around with, apologies for the mess</h3>
      <Row className="blog-row">
        {posts.map((post, index) => (
          <Col md={6} lg={4} className="mb-4 d-flex align-items-stretch" key={index}>
            <Card
              className="blog-card"
              style={{
                border: `5px solid transparent`, 
                borderImage: generateGradientBorder(post.title),
                borderImageSlice: 1,
                height: '300px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <CardBody>
                <CardTitle tag="h5">{post.title}</CardTitle>
                <CardText>{post.description}</CardText>
                <CardText className="text-muted">{post.date}</CardText>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Home;
